var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailEnvelopeLetterSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    id: "Letter",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M371.518,232.8H38.647v50.149h10v-35.408L188.73,348.063c4.892,3.51,10.622,5.265,16.354,5.265     c5.73,0,11.463-1.755,16.354-5.265l57.081-40.961l-5.83-8.125l-57.081,40.962c-6.296,4.517-14.754,4.517-21.048-0.001     L59.191,242.8h291.782l-47.104,33.802l5.83,8.125l51.818-37.185v175.462l-108.436-84.558l-6.148,7.886l105.051,81.918H58.187     l105.044-81.918l-6.15-7.886L48.647,423.007V302.238h-10V438.25h332.87V232.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 9.999,
    transform: "matrix(0.8124 -0.5831 0.5831 0.8124 -115.389 224.6395)",
    width: 13.326,
    x: 284.791,
    y: 286.665
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 26.478,
    x: 261.095,
    y: 137.745
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 144.608,
    x: 287.572,
    y: 177.808
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 171.086,
    x: 261.095,
    y: 205.304
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 42.512,
    x: 389.669,
    y: 232.8
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 42.636,
    x: 304.002,
    y: 137.745
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 42.512,
    x: 389.669,
    y: 356.078
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 42.512,
    x: 389.669,
    y: 379.412
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.443,118.265h-17.819v-16.7c0-9.826,7.994-17.819,17.819-17.819s17.819,7.993,17.819,17.819v113.181h10V101.564     c0-6.775-2.437-12.989-6.477-17.819h213.747c12.583,0,22.819,11.597,22.819,25.851v318.66h-73.684v9.999h83.684V109.596     c0-19.769-14.723-35.851-32.819-35.851h-235.09c-15.34,0-27.819,12.479-27.819,27.819v26.7h27.819V118.265z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailEnvelopeLetterSvgrepoCom);
export default __webpack_public_path__ + "static/media/email-envelope-letter-svgrepo-com.f92e61359ad68a964f8fe6f3fe073e08.svg";
export { ForwardRef as ReactComponent };